import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import UserMenu from './UserMenu';
import NavMenu from './NavMenu';
import { Tabs, Tab, Content } from "./Tab";
import Tools from './Tools';
import Sidebar from './Sidebar';
import Toast from './Toast';
import MoreMenu from './ui/moreMenu/MoreMenu';
import './css/Home.css';
import ModalWindow from './ModalWindow';
import Box from './Box';
import { now } from 'moment';
import Alert from './Alert';
import { ReactComponent as CallIcon } from '../components/icons/call.svg';
import Popover from './ui/Popover';
import './css/Campaigns.css';

const Campaigns = (props) => {
    const [assistedCampaigns, setAssistedCampaigns] = useState([]); 
    const [assistedCampaignsPagination, setAssistedCampaignsPagination] = useState(null);
    const [progressiveCampaigns, setProgressiveCampaigns] = useState([]); 
    const [progressiveCampaignsPagination, setProgressiveCampaignsPagination] = useState(null);
    const [campaign, setCampaign]= useState({}); 
    const [currentCampaign, setCurrentCampaign]= useState(null); 
    const [sessionData, setSessionData] = useState({}); 
    const [error, setError] = useState(false);
    const history = useHistory();
    const [toastRef, setToastRef] = useState(React.createRef()); 
    const [loading, setLoading] = useState({});
    const [data, setData] = useState({ scheduleDate: new Date() }); 
    const [asteriskQueues, setAsteriskQueues] = useState([]); 
    const [visibleModalChangeRatio, setVisibleModalChangeRatio] = useState(false);
    const [selectedCampaignToChangeRadio, setSelectedCampaignToChangeRadio] = useState(null);
    const [tabActive, setTabActive] = useState(0);
    const [campaignId, setCampaignId] = useState(null);
    const [idPopupVisible, setIdPopupVisible] = useState(null);

    

    const demoFunction = (str) => {
        console.log(str);
    };

    const handleClick = e => {
        const index = parseInt(e.target.id, 0);
        if (index !== tabActive) {
            setTabActive(index);
        }
    };

    const hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
    const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            //campaigns
            getProgressiveCampaigns();
            getAssistedCampaigns();
        }
    }, []);

    useEffect(() => {
        //AUTO SELECT PRESELECTED CAMPAIGN IN PREVIOUS SESSIONS (IF EXIST IN LIST)
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        assistedCampaigns.map((listValue, index) => {
            if (listValue._id === currentSessionData.lastCampaignId) {
                let preselectedCampaignFromDB = { 
                    'campaignId': listValue._id, 
                    'companyId': listValue.companyId, 
                    'campaignName': listValue.name, 
                    'itemCount': listValue.itemCount, 
                    'ammount': listValue.ammount, 
                    'companyName': listValue.company_info.name, 
                    'type': listValue.type, 
                    'asteriskQueue': listValue.asteriskQueueInfo?listValue.asteriskQueueInfo.name:null
                };
                setCampaign(preselectedCampaignFromDB);
                sessionStorage.setItem('selectedCampaign', JSON.stringify(preselectedCampaignFromDB));
            }
        });
    }, [assistedCampaigns]);

    const logout = () => {
        alert('Se sesión de usuario ha finalizado, es necesario que vuelva a iniciar sesión.');
        sessionStorage.clear();
        history.push('/login');
    }

    const getAssistedCampaigns = (pagination = null) => {
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setSessionData(currentSessionData);

        //get ASSISTED CAMPAIGNS
        let serviceParams = {campaignType:'ASSISTED'};
        if (pagination) { serviceParams.pagination = pagination }
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaignsByType`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };
        axios(options).then(response => {
            if (pagination) {
                setAssistedCampaigns([...assistedCampaigns, ...response.data[0].data]);
            }
            else {
                setAssistedCampaigns(response.data[0].data);
            }

            setAssistedCampaignsPagination(response.data[0].metadata[0]);
            setLoading(false);
        })
        .catch(function (error) {
            error.contextInfo='al recuperar la lista de campañas asistidas';
            setError(error);
            setLoading(false);
        });
    }

    const getProgressiveCampaigns = (pagination = null) => {
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setSessionData(currentSessionData);

        //get PROGRESSIVE CAMPAIGNS
        let serviceParams = {campaignType:'PROGRESSIVE'};
        if (pagination) { serviceParams.pagination = pagination }
        let options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaignsByType`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };
        axios(options).then(response => {
            if (pagination) {
                setProgressiveCampaigns([...progressiveCampaigns, ...response.data[0].data]);
            }
            else {
                setProgressiveCampaigns(response.data[0].data);
            }

            setProgressiveCampaignsPagination(response.data[0].metadata[0]);
            setLoading(false);
        })
        .catch(function (error) {
            error.contextInfo='al recuperar la lista de campañas progresivas';
            setError(error);
            setLoading(false);
        });
    }


    const getAsteriskQueues = (currentCampaign) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/asteriskQueues`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { companyId: currentCampaign.companyId}
        };
        axios(options).then(response => {
            setAsteriskQueues(response.data)
        });
    }

    const scheduleCurrentCampaign = (currentCampaign)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaign`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: data
        };
        axios(options).then(response => {
            console.log('🐞DEBUG response:', response);
            setCurrentCampaign(null);
            getAssistedCampaigns();
            getProgressiveCampaigns();
            toastRef.current.addToast('Se agendó la campaña exitósamente', 5000);
        });
    }


    const executeUserAMIAction = (action)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/userAMIAction`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: action
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction responseeeeeeeeeee:', response);
        });
    }


    const assignCampaign = (selectedCampaign) => {

        console.log('🐞DEBUG selectedCampaign.type:',selectedCampaign.type);
        
        let campaign={
            'campaignId': selectedCampaign._id, 
            'companyId': selectedCampaign.companyId, 
            'campaignName': selectedCampaign.name, 
            'itemCount': selectedCampaign.itemCount,
            'companyName': selectedCampaign.company_info.name,
            'type':selectedCampaign.type
        };

        setCampaign(campaign); //hack (mejorar) para mantener en memoria la seleccionada para comparar
        
        //update session data on sessionStorage
        let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        sessionData.lastCampaignId = campaign.campaignId;
        sessionStorage.setItem('sessionData', JSON.stringify(sessionData));

        //connect to queue
        if (selectedCampaign.type ==='PROGRESSIVE'){
            executeUserAMIAction({ action:'QUEUEADD', queue:selectedCampaign.asteriskQueueInfo.name});
        }

        //update selected campaign on dataBase
        let data = { 'campaignId': campaign.campaignId };

        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/user`); 
        fetch(url, {
            method: 'PUT',
            contentType: 'application/json',
            headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data) 
        })
        .then(res => res.json())
        .then(
            (result) => {
                //refresh list
                const clonedCampaigns = [...assistedCampaigns];
                clonedCampaigns.map((listValue, index) => {
                    if (campaign && listValue._id === campaign.campaignId) {
                        listValue.campaignSelected=true;
                    }else{
                        listValue.campaignSelected = false;
                    }
                });
                setAssistedCampaigns(clonedCampaigns);
            },
            (error) => {
                console.log('Se produjo un errrooooor:', error);
                setError(error);
            }
        )
    }


    const unassignCampaign = () => {
        setCampaign(null);
        let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        sessionData.lastCampaignId = null;
        sessionStorage.setItem('sessionData', JSON.stringify(sessionData));

        let data = { 'campaignId': null };
        sessionStorage.removeItem('selectedCampaign');
        setCampaign({});

        //set last campaignId in DB
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/user`); 
        fetch(url, {
            method: 'PUT',
            contentType: 'application/json',
            headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data) 
        })
        .then(res => res.json())
        .then(
            (result) => {
                //refresh list
                const clonedCampaigns = [...assistedCampaigns];
                clonedCampaigns.map((listValue, index) => {
                    if (campaign && listValue._id === campaign.campaignId) {
                        listValue.campaignSelected=true;
                    }else{
                        listValue.campaignSelected = false;
                    }
                });
                setAssistedCampaigns(clonedCampaigns);
            },
            (error) => {
                console.log('Se produjo un errrooooor:', error);
                setError(error);
            }
        )
    }

    const deleteCampaign = (selectedCampaig) => {
        if (window.confirm("¿Está seguro de eliminar la campaña seleccionada?")){
            let data = { 'campaignId': selectedCampaig._id };
            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/campaign`);
            fetch(url, {
                method: 'DELETE',
                contentType: 'application/json',
                headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(data) 
            })
            .then(res => res.json())
            .then(
                (result) => {
                    //refresh list
                    getAssistedCampaigns();
                    getProgressiveCampaigns();
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
        }
    }

    const resumeCampaign=(campaign)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            //url: `${process.env.REACT_APP_URI_API_CRM}/resumeCampaign`,
            url: `${process.env.REACT_APP_URI_API_CRM}/resumeNowPendingCallsOfCampaign`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                campaignId:campaign._id, ateriskQueue:campaign.asteriskQueueInfo.dialerQueue
            }
        };
        axios(options).then(response => {
            getProgressiveCampaigns();
            toastRef.current.addToast('Se reanudó campaña', 5000);
        });
    }

    const pauseCampaign=(campaign)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/pauseCampaign`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                campaignId:campaign._id, ateriskQueue:campaign.asteriskQueueInfo.dialerQueue
            }
        };
        axios(options).then(response => {
            getProgressiveCampaigns();
            toastRef.current.addToast('Se pausó campaña', 5000);
        });
    }

    const stopCampaign=(campaign)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/stopCampaign`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                campaignId:campaign._id, ateriskQueue:campaign.asteriskQueueInfo.dialerQueue
            }
        };
        axios(options).then(response => {
            getProgressiveCampaigns();
            toastRef.current.addToast('Se detuvo campaña', 5000);
        });
    }

    const refreshCampaignsAndNotify = (selectedCampaigntype) =>{
        switch (selectedCampaigntype) {
            case 'NEW':
                toastRef.current.addToast('Se creó nueva campaña exitósamente', 5000);
                getAssistedCampaigns();
                break;
            case 'REDUCTION':
                toastRef.current.addToast('Se creó nueva campaña (rebaja) exitósamente', 5000);
                break;
        } 
    }

    const executeNow=(campaign)=>{
        if(window.confirm("Está seguro de ejecutar ahora la campaña  " + campaign.name + '?')){
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/campaignExcecuteNow`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {campaignId:campaign._id}
            };
            axios(options).then(response => {
                //console.log('🐞DEBUG response:', response);
                getProgressiveCampaigns();
                toastRef.current.addToast('Se inició ejecucución de campaña',5000);
            });
        }
    }

    const changeRatioDialing=(campaign)=>{
        setVisibleModalChangeRatio(true);
        setSelectedCampaignToChangeRadio(campaign);
    }

    const applyChangeRatioDialing=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/campaignRatio`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {
                    campaignId:selectedCampaignToChangeRadio._id,
                    ratioDialing:data.ratioDialing,
                    campaignDialerQueue:selectedCampaignToChangeRadio.asteriskQueueInfo.dialerQueue
                }
            };
            axios(options).then(response => {
                //console.log('🐞DEBUG response:', response);
                getProgressiveCampaigns();
                setVisibleModalChangeRatio(false);
                toastRef.current.addToast('Se modificó el ratio de campaña',5000);
            });
    }

    const scheduleCampaign=(campaign)=>{
        setCurrentCampaign(campaign);
        getAsteriskQueues(campaign);
        setData({ ...data, ['campaignId']: campaign._id });
    }

    const handleCalendar = (dateValue) => {
        setData({ ...data, ['scheduleDate']: dateValue })
    }

    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }


    return (
        <div className="mainWrapper">
            <Toast ref={toastRef}></Toast>
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            {currentCampaign?(
                <ModalWindow closeMethod={()=>{setCurrentCampaign(null)}}>
                    <h2 className='title'>Agendar campaña</h2>
                    <span className="upper subtitle">Seleccione los datos para el agendamiento para la<br/>campaña seleccionada</span>

                    <div className="flexRow">
                        <div className="flexCol">
                            <Box className="x3" type="readOnly" label="campaña" value={currentCampaign.name} />
                            <Box type="calendar" name='scheduleDate' label="Agendamiento" selectedDate={data.scheduleDate}  onChange={handleCalendar} required></Box>
                        </div>
                    </div>

                    <div className="flexRow">
                        
                        <div className="flexCol">
                            <div className="inputWrapper twoSelects">
                                <label className="required">Hora</label>
                                <div className="wrapper">
                                    <select name="hour" defaultValue="" onChange={handleInputChange}>
                                        <option value="" disabled hidden>--</option>
                                        {hours.map((option, index) =>
                                            <option key={index} value={option}>{option}</option>
                                        )}
                                    </select>
                                    <span>:</span>
                                    <select name="minute" defaultValue="" onChange={handleInputChange}>
                                        <option value="" disabled hidden>--</option>
                                        {minutes.map((option, index) =>
                                            <option key={index} value={option}>{option}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        
                            <Box type="select" name="asteriskQueue" label="Cola Asterisk" className="x3" placeholder="Seleccione ..." options={asteriskQueues} onChange={handleInputChange} required></Box>
                            <button className="default collapsed" onClick={() => scheduleCurrentCampaign(currentCampaign)}>Agendar</button>
                        </div>
                    </div>

                    <p class="disclaimer">* Atención: Esto transformará esta campaña como PROGRESIVA</p>
                    
                </ModalWindow>):null
            }

            {visibleModalChangeRatio?(
                <ModalWindow closeMethod={()=>{setVisibleModalChangeRatio(false)}}>
                <h2 className='title'>Modificar ratio de discado</h2>
                <span className="upper subtitle">Seleccione el ratio de discado para la<br/>campaña seleccionada</span>
                <div className="flexRow">
                    <div className="flexCol">
                        <Box type="select" name="ratioDialing" label="ratio" className="" placeholder="Seleccione ..." options={[{ratio:1, desc:'1'},{ratio:1.5, desc:'1.5'},{ratio:2, desc:'2'},{ratio:2.5, desc:'2.5'},{ratio:3, desc:'3'}]} onChange={handleInputChange} required></Box>
                        <button className="default collapsed" onClick={() => applyChangeRatioDialing()}>Modificar</button>
                    </div>
                </div>
                </ModalWindow>
            ):null}

            <div className="main">
            
            {error ? (
                <Alert className="error center">
                    <p>Se produjo un error {error.contextInfo} ({error.response.status}  {error.response.statusText}).
                    {error.response.status === 401?(
                        <span> Es necesario volver a <a className='link' onClick={logout}>iniciar su sesión de usuario</a></span>):null
                    }
                    </p>    
                </Alert>):null
            } 

            <div className="headerWrapper">
                <div className="titleWrapper">
                    <h1 className={loading?'loading':''}>Campañas (Admin)</h1>
                    <span className="upper">Seleccione la campaña con la que desea conectarse.</span>
                </div>
                <div className="flexWrapper"> 
                        <UserMenu profile={sessionData.profile_desc} />
                </div>
            </div>

            <div className="tabsWrapper">
                <Tabs className='tabset'>
                    <Tab onClick={handleClick} active={tabActive === 0} id={0}>Progresivas</Tab>
                    <Tab onClick={handleClick} active={tabActive === 1} id={1}>Asistidas</Tab>
                </Tabs>

                {tabActive===0?(
                <button className='refresh' onClick={()=>getProgressiveCampaigns()}>Refrescar</button>
                ):(
                <button className='refresh' onClick={()=>getAssistedCampaigns()}>Refrescar</button>
                )}
            </div>
                    
            <Content active={tabActive === 0} className="tabContent campaigns fullHeight">
                {/* {progressiveCampaigns.filter(cmp => cmp.type ==='PROGRESSIVE').map((campaign, index) => { */}
                {progressiveCampaigns.map((campaign, index) => {    
                    return (
                        <div key={index} className={"campaigWrapper flexRow " + (campaign.status_info.code).toLowerCase()}>
                            <div className="flexCol">
                                <h2 className='rel'>
                                    <a onClick={() => setIdPopupVisible(idPopupVisible===campaign._id?null:campaign._id)}><i className='info inline'/></a>
                                    <Popover show={idPopupVisible===campaign._id} position="right">
                                        <dl>
                                            <dt>Id Campaña</dt>
                                            <dd>{campaign._id}</dd>
                                            <dt>Id Asignación</dt>
                                            <dd>{campaign.assignmentId}</dd>
                                            <dt>Clientes con gestiones</dt>
                                            <dd>{campaign.tasksLength}</dd>
                                        </dl>
                                    </Popover>
                                    {campaign.name} <span>{campaign.status_info.desc}</span></h2>
                                <h3>{campaign.company_info.name}</h3>
                                
                                {/* {campaign.executionDate?(
                                    <p>Clientes {Tools.fmtClNumber(campaign.itemCount)} | Iniciada en {Tools.fdtCL(campaign.executionDate)}</p>):(
                                    <p>Clientes {Tools.fmtClNumber(campaign.itemCount)} | Programada para {Tools.fdtCL(campaign.schedulingDate)}</p>
                                )} */}

                                <div className="flexRow">
                                    <div className="toggleButtons">
                                        <button onClick={()=>executeNow(campaign)} disabled={campaign.status_info.code==='PAUSED' || campaign.status_info.code==='RUNNING'}><i className="play"></i>Iniciar</button>
                                        {campaign.status_info.code==='PAUSED'?
                                        (<button onClick={()=>resumeCampaign(campaign)}><i className="resume"></i>Reanudar</button>):
                                        (<button disabled={campaign.status_info.code!=='RUNNING'} onClick={()=>pauseCampaign(campaign)}><i className="pause"></i>Pausar</button>)}
                                        <button disabled={campaign.status_info.code!=='RUNNING'} onClick={()=>stopCampaign(campaign)}><i className="stop"></i>Detener</button>
                                    </div>
                                    <div className='toggleSection'>
                                        <button onClick={()=>changeRatioDialing(campaign)}>Cambiar ratio</button>
                                    </div>
                                </div>

                            </div>
                            <div className="flexCol">
                                <div className="flexRow">
                                    <div className='indicator'><span className='label'>Ratio</span><h1>{campaign.ratioDialing}</h1></div>
                                    <div className='indicator'><span className='label'>Abandonos</span><h1>{Tools.fmtClNumber(campaign.abandonments)}</h1></div>
                                    <div className='indicator'><span className='label'>Avance</span>
                                        <div className="pie forCampaigns" tasks-length={((campaign.tasksLength * 100) / campaign.itemCount).toFixed(0)+'%'} style={{ "--completed": ((campaign.tasksLength * 100) / campaign.itemCount).toFixed(0) + '%' }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {
                progressiveCampaignsPagination ? (
                        <p className="pagination">
                            Mostrando [{progressiveCampaigns.length} de {progressiveCampaignsPagination.total} registros]
                            {(progressiveCampaigns.length < progressiveCampaignsPagination.total) ? (
                                <span> &nbsp; <a className={loading.campaigns ? 'link loading' : 'link'} onClick={() => getProgressiveCampaigns({ page: progressiveCampaignsPagination.page + 1, skip: progressiveCampaigns.length, limit: 10 })}>Ver más</a></span>
                            ) : null}
                        </p>
                    ) : null
                }

            </Content>

            <Content active={tabActive === 1} className="tabContent midHeight">
                
                <table className="fullWidth">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>Cliente</th>
                            <th>Nombre campaña</th>
                            <th>Creación</th>
                            <th className="right">Clientes</th>
                            <th className="right">Monto deuda</th>
                            <th>Creada por</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* {assistedCampaigns.filter(cmp => cmp.type ==='ASSISTED').map((listValue, index) => { */}
                        {assistedCampaigns.map((listValue, index) => {     
                            return (
                                <tr key={index} className={`${(listValue._id === campaign.campaignId)?'selected':''} ${(!listValue.active)?'inactive':''}`}>
                                    <td>{listValue.type==='ASSISTED'?(<i className="assisted mask"></i>):<i className="progressive mask"></i>}</td>
                                    <td>{listValue.company_info.name}</td>
                                    <td className='rel'>
                                        <a onClick={() => (listValue._id === campaignId)?setCampaignId(null):setCampaignId(listValue._id)}><i className='info'/></a> {listValue.name}
                                        <Popover show={listValue._id === campaignId} position="right">
                                            <dl>
                                                <dt>Id Campaña</dt>
                                                <dd>{listValue._id}</dd>
                                                <dt>Id Asignación</dt>
                                                <dd>{listValue.assignmentId}</dd>
                                                <dt>Clientes con gestiones</dt>
                                                <dd>{listValue.tasksLength}</dd>
                                            </dl>
                                        </Popover>
                                    </td>
                                    <td>{Tools.fdtCL(listValue.date)}</td>
                                    <td className="right">{Tools.fmtClNumber(listValue.itemCount)}</td>
                                    <td className="right">{Tools.fmtClAmmount(listValue.ammount)}</td>
                                    <td>{listValue.user_info.name}</td>
                                    <td className='sticky lastSticked'>  
                                        {listValue.active?(
                                            <MoreMenu menuList={
                                                [
                                                    {
                                                        title: "Ver detalle",
                                                        action: () => { history.push("/campaign/" + listValue._id)},
                                                        visible:true
                                                    },

                                                    {
                                                        title: "Agendar ejecución",
                                                        action: () => scheduleCampaign(listValue),
                                                        visible: (sessionData.profile_code === 'SUPV')
                                                    },
                                                    {
                                                        title: "Ejecutar ahora",
                                                        action: () => { executeNow(listValue);},
                                                        visible: (sessionData.profile_code === 'SUPV' && listValue.type ==='PROGRESSIVE')
                                                    },
                                                    {
                                                        title: "Cambiar ratio discado",
                                                        action: () => { changeRatioDialing(listValue);},
                                                        visible: (sessionData.profile_code === 'SUPV' && listValue.type ==='PROGRESSIVE')
                                                    },
                                                    {
                                                        title: "Eliminar",
                                                        action: () => { deleteCampaign(listValue)},
                                                        visible: (sessionData.profile_code === 'SUPV')
                                                    }
                                                ]
                                            }/>
                                        ):null}
                                    </td>
                                </tr>  
                            );      
                        })}   
                    </tbody>            
                </table>
                

                {
                    assistedCampaignsPagination ? (
                        <p className="pagination">
                            Mostrando [{assistedCampaigns.length} de {assistedCampaignsPagination.total} registros]
                            {(assistedCampaigns.length < assistedCampaignsPagination.total) ? (
                                <span> &nbsp; <a className={loading.campaigns ? 'link loading' : 'link'} onClick={() => getAssistedCampaigns({ page: assistedCampaignsPagination.page + 1, skip: assistedCampaigns.length, limit: 10 })}>Ver más</a></span>
                            ) : null}
                        </p>
                    ) : null
                }
            </Content>
                
            <br/>

            {/* <button type="button" className='default' onClick={() => assignCampaign()} disabled={!campaign.campaignId}>Seleccionar campaña</button>  */}
        </div>
        </div>
    );
}

export default Campaigns;